/**
 * created by yxy
 工具栏修改图片
 *
 */
import React, {Component} from 'react';
import {Input, InputNumber, message, Modal, Switch, Tooltip} from "antd";
import {buildInsertPicHtml} from "../../../toolsSpace/tools/pictureTool/pictureTool"
import TaskPicture from "../../../../Interview/components/btn/TaskPicture";
import {uuid} from "../../../../../utils"
import leftSideIcon from "../../image/leftside.png";
import leftCenterIcon from "../../image/leftCenter.png";
import rightCenterIcon from "../../image/rightCenter.png";
import centerIcon from "../../image/center.png";
import $Jq from "jquery";
import $ from "jquery";
import BaseComponent from "../../../../../base/BaseComponent";

export default class InterviewTaskPicture extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            valueImg: '',
            value: '',
            sizeWidth: '',
            sizeHeight: '',
            vspaceValue: '',
            titleValue: '',
            borderValue: 0,
            srcValue: '',
            isDisplay: "none",
            isDisplayBlue: 'block',
            float: null,
            cssWater: '',
            taskId: '', //当前数据的id
            checkData: [],
            ratio: ''
        };

    }

    componentDidMount() {
        if (this.urlParams) {
            let taskId = this.urlParams.taskId;
            this.setIds({taskId});
        }
    }

    setIds = ({taskId}) => {
        this.state.taskId = taskId;
        this.setState({taskId: taskId})
    };
    open = (img) => {
        this.state.ratio = img.width / img.height;
        let float = null;
        if (img.style.float) {
            float = img.style.float;
        } else {
            let $imgParent = $(img).parent();
            if ($imgParent.length > 0) {
                if ($imgParent.css("textAlign") === "center") {
                    float = "center";
                }
            }
        }
        this.setState({
            valueImg: img,
            sizeWidth: img.width,
            sizeHeight: img.height,
            vspaceValue: img.vspace,
            borderValue: img.border,
            titleValue: img.name,
            srcValue: img.src,
            float
            // float:$Jq(img).parent().is(":contains('center')")?"center":this.state.float,
        });
        this.setState({visible: true})
    };

    onOk = () => {
        let newArray = []
        let {checkData} = this.state;
        checkData && checkData.length && checkData.forEach((item, index) => {
            if (item.checked) {
                newArray.push(item)
            }
        });
        let imgHTML = '';
        let {float, borderValue, vspaceValue, sizeWidth, sizeHeight} = this.state;
        newArray && newArray.length && newArray.forEach((item, index) => {
            imgHTML += buildInsertPicHtml({
                url: item.path,
                float: float,
                border: borderValue,
                vspace: vspaceValue,
                width: sizeWidth,
                height: sizeHeight,
            });
        });
        let isSuccess = true;
        if (imgHTML) {
            isSuccess = this.props.editor.rmtExecCommand("inserthtml", imgHTML);
        }
        if(isSuccess) {
            this.onClose();
        }
    };

    onClose = () => {
        if (typeof this.props.onCloseCall === 'function') {
            this.props.onCloseCall()
        }
        this.setState({visible: false})
    };

    showModal = () => {

        this.setState({
            visible: true
        })
    };

    imageLabelId = "a_" + uuid();

    render() {
        let baseStyle = {marginLeft: 15, cursor: "pointer"};
        let defaultStyle = {...baseStyle, border: "1px solid #FFF"};
        let defaultWidth = 500;
        let defaultWaterPic = this.state.waterPicList && this.state.waterPicList.find(water => water.status === 1);
        if (!defaultWaterPic) {
            this.state.cssWater = false;
        }
        let checkedStyle = {
            ...baseStyle,
            borderTop: "solid 1px #000",
            borderLeft: "solid 1px #000",
            borderRight: "solid 1px #DCDCDC",
            borderBottom: "solid 1px #DCDCDC"
        };
        return (
            <div>
                <Modal
                    title={this.props.title}
                    visible={this.state.visible}
                    maskClosable={false}
                    width={800}
                    onCancel={this.onClose}
                    className={'InterviewTaskPic'}
                    onOk={this.onOk}
                >
                    <div>
                        <div style={{
                            display: 'flex',
                            justifyContent: "end",
                            borderBottom: '1px solid  rgba(0, 0, 0, 0.06)',
                            paddingBottom: '16px',
                        }}>
                            <div>
                                浮动方式：
                                <Tooltip title={"无浮动"} onClick={() => {
                                    this.setState({float: null})
                                }}><img style={this.state.float === null ? checkedStyle : defaultStyle}
                                        src={leftSideIcon}/></Tooltip>
                                <Tooltip title={"左浮动"} onClick={() => {
                                    this.setState({float: "left"})
                                }}><img style={this.state.float === "left" ? checkedStyle : defaultStyle}
                                        src={leftCenterIcon}/></Tooltip>
                                <Tooltip title={"右浮动"} onClick={() => {
                                    this.setState({float: "right"})
                                }}><img style={this.state.float === "right" ? checkedStyle : defaultStyle}
                                        src={rightCenterIcon}/></Tooltip>
                                <Tooltip title={"居中独占一行"} onClick={() => {
                                    this.setState({float: "center"})
                                }}><img style={this.state.float === "center" ? checkedStyle : defaultStyle}
                                        src={centerIcon}/></Tooltip>
                            </div>
                        </div>
                        <TaskPicture
                            id={this.state.taskId}
                            showCheck={true}
                            current={'2'}
                            callBack={(data) => {
                                this.setState({checkData: data})
                            }}>
                        </TaskPicture>
                        <div style={{height: 32, display: "flex", lineHeight: "32px", marginBottom: '10px'}}>
                            <div> 最大宽度 &nbsp; <InputNumber style={{width: 68}} min={0} value={this.state.sizeWidth}
                                                           onChange={value => {
                                                               if (!this.state.ratio) {//解决网络图片地址插入的时候，宽高无法自适应
                                                                   let width = parseInt($(`#${this.imageLabelId}`).width());
                                                                   let height = parseInt($(`#${this.imageLabelId}`).height());
                                                                   this.state.ratio = width / height;
                                                               }
                                                               if (this.state.isDisplayBlue == "block") {
                                                                   this.setState({
                                                                       sizeWidth: value * 1,
                                                                       sizeHeight: (value / this.state.ratio).toFixed(0) * 1
                                                                   })
                                                               } else {
                                                                   this.setState({sizeWidth: value * 1})
                                                               }
                                                           }}/>&nbsp;px
                            </div>


                            <div style={{marginLeft: '20px'}}>
                                边框：<InputNumber min={0} style={{width: 68}}
                                                value={this.state.borderValue > 0 ? this.state.borderValue : 0}
                                                onChange={value => {
                                                    this.setState({borderValue: value})
                                                }}/>
                                <span style={{color: "rgba(0, 0, 0, 0.85)"}}>&nbsp;px</span>
                            </div>
                            <div style={{marginLeft: '20px'}}>
                                边距：<InputNumber min={0} style={{width: 68}} placeholder="0"
                                                value={this.state.vspaceValue}
                                                onChange={value => {
                                                    this.setState({vspaceValue: value})
                                                }}/>
                                <span style={{color: "rgba(0, 0, 0, 0.85)"}}>&nbsp;px</span>
                            </div>
                            <div style={{marginLeft: '190px'}}>
                                <span style={{marginRight: 10}}>图片水印</span>
                                <Switch checkedChildren="开" unCheckedChildren="关" defaultChecked={this.state.cssWater}
                                        onChange={(value) => {
                                            this.inputNumberOnChange(value, 'cssWater')
                                        }}/>
                            </div>
                        </div>
                    </div>
                </Modal>
                <style>{
                    `.InterviewTaskPic .ant-modal-body{padding-bottom:0;padding-top:16px}`
                }</style>
            </div>
        )
    }

    inputNumberOnChange(value, type = 'width') {
        this.state[type] = value;
        this.setState({});
    }

}